import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { HoraBloqueoClientes } from '@shared/models/controlCredito/HoraBloqueoClientes';
import { MessageService } from '@shell/message.service';

@Component({
  selector: 'app-modificar-hora-bloqueo',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './modificar-hora-bloqueo.component.html'
})
export class ModificarHoraBloqueoComponent implements OnInit {

  @Input() horaActualConfiguracion: HoraBloqueoClientes;

  horaActual: string;
  form: FormGroup = new FormGroup({});
  horasDisponibles: string[] = [];
  guardandoHora: boolean = false;

  constructor(private fb: FormBuilder, private activeModal: NgbActiveModal, private controlCreditoService: ControlCreditoService,
    private messageService: MessageService) { }

  ngOnInit(): void {
      this.horaActual = this.horaActualConfiguracion.fechaActual;
      this.crearForm();
      this.generarHoras();
  }

  crearForm() {
    this.form = this.fb.group({
      horaActual: [{ value: this.extraerHora(this.horaActual), disabled: true }],
      nuevaHora: ['', Validators.required],
      motivo: ['', Validators.required]
    });
  }

  generarHoras() {
    this.horasDisponibles = Array.from({ length: 24 }, (_, i) =>
      i.toString().padStart(2, '0') + ':00'
    );
  }

  extraerHora(dateTimeString: string): string {
    if (!dateTimeString) return '';
    const date = new Date(dateTimeString);
    const horas = date.getHours().toString().padStart(2, '0');
    return `${horas}:00`;
  }

  onGuardar() {
    if (this.form.valid) {
      const dto = new HoraBloqueoClientes()
      dto.fechaAnterior = this.form.get('horaActual')?.value;
      dto.fechaActual = this.form.get('nuevaHora')?.value;
      dto.motivo = this.form.get('motivo')?.value;
      this.guardandoHora = true;
      this.controlCreditoService.modificarHoraBloqueoClientes(dto).subscribe(h => {
        this.guardandoHora = false;
        this.activeModal.close(h);
      }, () => {
        this.guardandoHora = false;
        this.messageService.showErrorMessage('Ha habido un eror al modificar la hora de bloqueo.');
      }) 
    }
  }

  onCancelar() {
    this.activeModal.dismiss();
  }

  get motivo() {
    return this.form.get('motivo');
  }
}
